<template>
	<div class="c-blog-posts-list-container">
		<c-loader class="c-project-list" v-if="loading"/>
		<section class="c-blog-posts-list" :class="{ compact: compact }" v-else>
			<div class="container">
				<ul class="c-blog-posts-list__list">
					<li class="c-blog-posts-list__item" v-for="post in posts" v-if="post && !post.sticky">
						<h3 class="c-blog-posts-list__title">
							<router-link
								:key="post.slug"
								:to="settings.currentLang === 'en-us' ? '/en/blog/' + post.slug : '/blog/' + post.slug">
								{{ post.title }}
							</router-link>
						</h3>
						<span class="c-blog-posts-list__date">{{ post.transformedDate }}</span>
						<div v-html="post.abstract"></div>

						<router-link class="c-blog-posts-list__link"
							:key="post.slug"
							:to="settings.currentLang === 'en-us' ? '/en/blog/' + post.slug : '/blog/' + post.slug">
							{{ localizedReadMoreText }}
						</router-link>
					</li>
				</ul>
				<router-link v-if="button === 'allPosts'" :to="settings.currentLang === 'en-us' ? '/en/blog/' : '/blog/'" class="c-blog-posts-list__button">{{ localizedAllPostsText }}</router-link>
			</div>
		</section>
	</div>
</template>

<script>
import CLoader from '@/components/Loader'

export default {
	name: 'blog-posts-list',
	components: {
		CLoader
	},
	props: ['button', 'posts', 'compact', 'loading'],
	data: () => ({
		allPostsText: {
			'en-us': 'To the blog',
			'de-ch': 'Zum Blog'
		},
		readMoreText: {
			'en-us': 'Read more',
			'de-ch': 'Weiterlesen'
		}
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings;
		},
		localizedAllPostsText() {
			return this.allPostsText[this.settings.currentLang];
		},
		localizedReadMoreText() {
			return this.readMoreText[this.settings.currentLang];
		}
	}
};
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.c-blog-posts-list-container {
		position: relative;
		min-height: 200px; // optical – make sure loader is visible
	}

	.c-blog-posts-list {
		padding: 0;

		&__list {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
		}

		&__item {
			margin-bottom: 2rem;
			width: 100%;
			max-width: 40rem;

			@include mq($from: medium) {
				.compact & {
					width: 45%;
				}
			}

			p {
				font-size: .9rem;
				color: $colorGray;
			}
		}
		&__date {
			display: inline-block;
			font-size: .9rem;
			font-family: $fontFamilyBase;
			color: $colorGray;
			margin-bottom: .5rem;
		}
		&__title {
			font-size: 1.6rem;
			font-weight: 600;
			line-height: 1.2;
			margin-bottom: 0;

			a {
				text-decoration: none;
			}

			.compact & {
				font-size: 1.2rem;
			}
		}
		&__link {
			display: inline-block;
			margin-top: .5rem;
			color: $colorBrandMain;
			font-size: .9rem;

			&:hover {
				color: $colorBrandSecondary;
			}
		}
		&__button {
			display: block;
			max-width: 14rem;
			font-weight: 600;
			text-align: center;
			margin: 1rem auto;
			background: none;
			font-family: $fontFamilyBase;
			font-size: .9rem;
			color: $colorBrandSecondary;
			border: 4px solid $colorBrandSecondary;
			padding: 0 .5rem;
			line-height: 2.5;
			cursor: pointer;

			&:hover, &:focus {
				border-color: $colorBrandMain;
				color: $colorBrandMain;
			}

			&, a {
				text-decoration: none;
			}
		}

	}

</style>



// WEBPACK FOOTER //
// BlogPostsList.vue?75273481